import { Translate } from "./TranslationUtils";

export const DisplayErrors = (errorObject, toast) => {
    if (errorObject?.detail) {
        toast.current.show({
            severity: "error",
            summary: "Помилка",
            detail: errorObject.detail,
            life: 3000
        });
        return;
    }

    const errors = extractErrors(errorObject);

    errors.forEach(({ field, message }) => {
        toast.current.show({
            severity: "error",
            summary: Translate(field),
            detail: Translate(message),
            life: 3000
        });
    });
};

const extractErrors = (obj, parentKey = null) => {
    let result = [];

    if (Array.isArray(obj)) {
        obj.forEach(item => {
            result = result.concat(extractErrors(item, parentKey));
        });
    }
    else if (typeof obj === "object" && obj !== null) {
        Object.entries(obj).forEach(([key, value]) => {
            result = result.concat(extractErrors(value, key));
        });
    }
    else if (typeof obj === "string") {
        result.push({
            field: parentKey,
            message: obj
        });
    }

    return result;
}